import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Newsletter as Newsletter$1 } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import '@grandvisionhq/lib-utils-html';
import { useBloomreachNewsletterData } from '../../hooks/use-bloomreach-newsletter-data.js';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsNewsletter = ({ component , meta  })=>{
    const newsletterData = useBloomreachNewsletterData();
    const { newsletterImage  } = component.getModels();
    const image = parseBloomreachImage(newsletterImage);
    const alignment = meta.template.includes('right') ? 'right' : 'left';
    return /*#__PURE__*/ React.createElement(Newsletter$1, swcHelpers.extends({}, newsletterData, {
        alignment: alignment,
        image: image === null || image === void 0 ? void 0 : image.original,
        mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
        variant: "bloomreach-component"
    }));
};
var Newsletter = compose(withHidableContent, withBloomreachData, withEditableContent)(CmsNewsletter);

export { CmsNewsletter, Newsletter as default };
//# sourceMappingURL=Newsletter.js.map
